angular.module('pe4h').filter('standardMonthDayYear', function () {
    return function (input) {
        if (input == null) {
            return "";
        }

        var d = new moment(input);
        return d.isValid() ? d.format("MM/DD/YYYY") : input;
    };
});

angular.module('pe4h').filter('localeDateHuman', function () {
    return function (input) {
        if (input == null) {
            return "";
        }

        return moment(input).format('MMM DD, YYYY');
    };
});

angular.module('pe4h').filter('calendarMethod', function () {
    return function (input) {
        if (input == null) {
            return "";
        }

        return moment(input).calendar(moment());
    };
});

angular.module('pe4h').filter('workCompletedBy', function () {
    return function (WorkCompletedBy, WorkCompletedByDate) {
        if (WorkCompletedBy == null) {
            return "";
        }
        var workCompletedByStr = '';
        switch (WorkCompletedBy) {
        case 0:
            workCompletedByStr = 'Within a week';
            break;
        case 1:
            workCompletedByStr = 'In the next 2-3 weeks';
            break;
        case 2:
            workCompletedByStr = 'In a month or longer';
            break;
        case 3:
            workCompletedByStr = moment(WorkCompletedByDate).format('MMM DD, YYYY');
            break;
        default:

        }

        return workCompletedByStr;
        
    };
});


